import {observer} from 'mobx-react';
import * as React from 'react';
import * as classnames from 'classnames/bind';
import bind from "bind-decorator";
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {GUID} from '@mintdata/mint-kit/api/models/GUID';

const styles = require('./CodeEditorPanel.less');
const cx = classnames.bind(styles);

export interface CodeEditorProps
{
	codeEditorId:GUID;
	value?: string;
	language?: string;
	onChange?: any;
}

@observer
export class CodeEditorPanel extends React.Component<CodeEditorProps, any>
{
    public render():JSX.Element
	{
		const {codeEditorId} = this.props;

		return  <div className={cx('codeEditorPanel')}>
                    <div className={cx('topbar')}>
                        <div className={cx('label')}>
                        Script
                        </div>
                    </div>
				    <iframe className={cx('codeEditorIFrame')}
						frameBorder="0" scrolling="no"
						src={`${paths.codeEditorBody()}#${codeEditorId}`}
				    />
                </div>
	}
}
